import $ from "jquery";
import Siema from "siema";
$(document).ready(function () {
    var controller = {};
    var controlled = {};
    $('.sliderWrapper').each(function (k, v) {
        var siema = $(v).find(".siema").get(0);
        var hasTimer = $(v).hasClass("has-timer");
        var byThree = $(v).hasClass("by-three");
        var controls = $(v).attr("data-controls");
        var prevNext = $(v).attr("data-prev-next");
        var hasControls = (controls != "");
        var hasPrevNext = (prevNext != "");
        var interval;
        var loop = $(v).hasClass("loop");
        var navigation = $(v).find(".navigation");
        var page = byThree == false ? 1 : {
            0: 2,
            768: 2,
            1024: 3
        };
        var isController = $(v).hasClass("controller");
        var isControlled = $(v).hasClass("controlled");
        var slider = new Siema({
            selector: siema,
            duration: 300,
            easing: 'ease-out',
            perPage: page,
            startIndex: 0,
            draggable: true,
            multipleDrag: false,
            threshold: 20,
            loop: loop,
            rtl: false,
            onInit: function () {
                navigation.find("span:eq(0)").addClass("current");
            },
            onChange: function () {
                if (hasTimer) {
                    clearInterval(interval);
                    interval = setInterval(function () { return slider.next(); }, 5000);
                }
                navigation.find(".current").removeClass("current");
                navigation.find("span:eq(" + slider.currentSlide + ")").addClass("current");
                if (hasControls) {
                    $(controls).children(".current").removeClass("current");
                    $(controls).children("li:eq(" + slider.currentSlide + ")").addClass("current");
                }
                if (isControlled) {
                    if (controller[$(v).attr("data-name")] !== void 0) {
                        controller[$(v).attr("data-name")].goTo(slider.currentSlide);
                    }
                }
                if (isController) {
                    if (controlled[$(v).attr("data-name")] !== void 0) {
                        controlled[$(v).attr("data-name")].goTo(slider.currentSlide);
                    }
                }
            }
        });
        if (isControlled)
            controlled[$(v).attr("data-name")] = slider;
        if (isController) {
            controller[$(v).attr("data-name")] = slider;
            $(v).on("click", ".action", function (e) {
                if (controlled[$(v).attr("data-name")] !== void 0) {
                    controlled[$(v).attr("data-name")].goTo($(e.currentTarget).parent().parent().index());
                }
            });
        }
        if (hasTimer) {
            interval = setInterval(function () { return slider.next(); }, 5000);
        }
        navigation.on("click", "span", function (e) {
            e.preventDefault();
            slider.goTo($(e.currentTarget).index());
        });
        if (hasControls) {
            $(controls).on("click", "a", function (e) {
                e.preventDefault();
                slider.goTo($(e.currentTarget).parent().index());
            });
        }
        if (hasPrevNext) {
            $(prevNext).on("click", "a", function (e) {
                e.preventDefault();
                if ($(e.currentTarget).hasClass("prev"))
                    slider.prev();
                else
                    slider.next();
            });
        }
    });
});
